import { EventType } from '../../enums/eventType';

export class EventData {
    type: EventType;
    cipherId: string;
    date: string;
}
